import axios from "axios";
import { loadUser } from "../state/slices/user";
import { store } from "../state/store";
const api = axios.create();

api.interceptors.request.use(
  function (config) {
    let state = store.getState();
    config.baseURL = state.customer.serverUrl;
    const url = config.url || '';
    const isSuperAdmin = !!(state.user?.user?.role?.capabilities?.customer_management?.view_customer_insights);
    const isExcludedEndpoint =
      url.startsWith('/customers/') ||
      url.startsWith('/super-admin/') ||
      url.startsWith('/users/logout') ||
      url.startsWith('/users/profile') ||
      url.startsWith('/users/preferences');

    if (isSuperAdmin && !isExcludedEndpoint) {
      const activeCustomerId = localStorage.getItem('managed_customer_id');
      if (activeCustomerId) {
        config.headers = config.headers || {};
        config.headers["X-Customer-ID"] = activeCustomerId;
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    let state = store.getState();
    if (
      error.response &&
      (error.response.status === 403 || error.response.status === 406) &&
      state.user.isAuthenticated === true
    ) {
      store.dispatch(loadUser());
    }
    return Promise.reject(error);
  }
);

export default api;
